module.exports = __webpack_public_path__ + "static/IBMPlexMono-BoldItalic-4289aa978c126b40c79130726684a5a7.woff2";